import { type Ref, type RefCallback } from "react";

/** Combines several refs into one callback ref, so a single element can be exposed through each of them. */
export const composeRefs =
  <T>(...refs: Array<Ref<T> | undefined>): RefCallback<T> =>
  (node: T | null): (() => void) => {
    const cleanups = refs.map((ref: Ref<T> | undefined): (() => void) | undefined => {
      if (typeof ref === "function") {
        const cleanup = ref(node);
        return typeof cleanup === "function"
          ? cleanup
          : (): void => {
              ref(null);
            };
      }

      if (ref) {
        ref.current = node;
        return (): void => {
          ref.current = null;
        };
      }

      return undefined;
    });

    return (): void => {
      cleanups.forEach((cleanup: (() => void) | undefined): void => {
        cleanup?.();
      });
    };
  };
